import { render, staticRenderFns } from "./AutoLogin.vue?vue&type=template&id=5631381e&"
import script from "./AutoLogin.vue?vue&type=script&lang=js&"
export * from "./AutoLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports